<template>
	<div>
		<div>
			<div v-html="getSelectedClass.VIEW_OPTIONS.CWP_INSTRUCTIONS"></div>

		</div>
		<div class="horizontal-tabs" v-if="Object.keys(selectedCourse).length > 0">
			<tabs :options="{ useUrlFragment: false, defaultTabHash: defaultTab }" style="margin-top:15px;">
				<tab :id="mp.MP_CODE"
						 :name="`${mp.MP_DESC} (${mp.MP_CODE})`"
						 :key="m"
						 v-for="(mp, m) in selectedCourse.MARKING_PERIODS">
					<table id="studentSchedule" class="table default-table table-striped table-bordered text-center">
						<thead>
							<tr v-if="selectedCourse.DAYS">
								<th>{{ periodDaysText }}</th>
								<th :key="l" v-for="(label, l) in selectedCourse.DAYS">
									<span v-if="showDayCode && showDayDesc">{{ label.DAY_DESC }} ({{ label.DAY_CODE }})</span>
									<span v-else-if="showDayDesc">{{ label.DAY_DESC }}</span>
									<span v-else-if="showDayCode">{{ label.DAY_CODE }}</span>
								</th>
							</tr>
							<tr v-else>
								<th colspan = "6"><p><em>{{ loadingMessageText }}</em></p></th>
							</tr>
						</thead>
						<tbody>
							<tr :key="p" v-for="(period, p) in selectedCourse.PERIODS">
								<td class="period">
									<div>
										<span v-if="showPeriodCode && showPeriodDesc">
											{{ period.PERIOD_DESC }} ({{ period.PERIOD_CODE }})
										</span>
										<span v-else-if="showPeriodDesc">{{ period.PERIOD_DESC }}</span>
										<span v-else-if="showPeriodCode">{{ period.PERIOD_CODE }}</span>
									</div>
									<div v-if="showPeriodTimes">
										<span>
											{{ period.PERIOD_START_TIME | time }}
										</span> - <span>
											{{ period.PERIOD_END_TIME | time }}
										</span>
									</div>
								</td>
								<td :key="d" v-for="(day, d) in selectedCourse.DAYS" :class="getCellStatus(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
									<div class="course-info" v-if="getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
										<div>
											<strong>
												{{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_TITLE }}
												<template v-if="showCourseID">
													 ({{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_ID }})
												</template>
											</strong>
											<font-awesome-icon icon="info-circle"
																				 v-if="getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_CATALOG_DESC"
																				 v-tooltip.top-center="{content: getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_CATALOG_DESC, trigger: 'hover click'}">
											</font-awesome-icon>
										</div>
										<div v-if="isSelectedTopic(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)"
												:class="getTopicsClass(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
											<div class="topic-head">
												<font-awesome-icon icon="times" @click="cancelTopic()" class="clickable"></font-awesome-icon>
												{{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).COURSE_CATALOG_DESC }}
											</div>
										</div>

										<div v-if="showTeacherName">
											{{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).STAFF_NAME }}
										</div>
										<div v-if="showRoomCode || showRoomDesc">
											<span v-if="showRoomDesc && showRoomCode">
												RM: {{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).ROOM_DESC }} ({{ getCourse( mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE ).ROOM_CODE }})
											</span>
											<span v-if="showRoomCode && !showRoomDesc">
												RM: {{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).ROOM_CODE }}
											</span>
											<span v-if="!showRoomCode && showRoomDesc">
												RM: {{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).ROOM_DESC }}
											</span>
										</div>
										<div v-if="showDurationCode && !!getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).DURATION_CODE">
											DUR: {{ getCourse(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE).DURATION_CODE }}
										</div>

										<div class="drop-course" v-if="getIsRemovable(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
											<font-awesome-icon class="clickable"
																				 icon="minus-circle"
																				 size="2x"
																				 @click="confirmCourseRemoval(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
											</font-awesome-icon>
										</div>
									</div>
									<div v-else
											class="clickable"
											@click="showAvailableClasses(mp.MP_CODE, period.PERIOD_CODE, day.DAY_CODE)">
										{{ emptyText }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</tab>
			</tabs>
		</div>

		<modal :modal-title="getModalTitle()"
					 :closeText="closeText"
					 :show="showModal" dialog-size="lg" name="mappingsModal" @close="$emit('closeModal')"
					 v-if="availableCourses">
			<template>
				<div class="alert alert-warning" v-if="conflict">
					<h4>{{ courseConflictMessage }}</h4>
				</div>
				<div class="row filter-bar">
					<div class="col-sm-6">
						<label>{{ filterByText }}</label>
						<select class="form-control" v-model="filterBy">
							<option value="">{{ allDepartmentsText }}</option>
							<option :key="d" v-for="(dept, d) in departments" :value="dept.DEPARTMENT_CODE">
								{{ dept.DEPARTMENT_DESC }}
							</option>
						</select>
					</div>
					<div class="col-sm-6">
						<div class="toggle-buttons">
							<toggle-button :value="false"
														 :cssColors="true"
														 v-model="showUnavailable">
							</toggle-button>
							<label>
								{{ showUnavailableClassesText }} <span class="badge">{{ unavailableCount }}</span>
							</label>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="toggle-buttons">
							<toggle-button :value="false"
														 :cssColors="true"
														 v-model="showDescriptions">
							</toggle-button>
							<label>
								{{ showCourseDescriptionsText }}
							</label>
						</div>
					</div>
				</div>
				<br />
				<table class="table table-default table-striped">
					<tbody>
						<template v-for="(available, a) in availableCourses">
							<tr :key="a"
									v-if="displayIt(available)"
									:class="{'unavailable': (available.IS_CONFLICT_FLG === 'Y' || available.SEATS_AVAILABLE <= 0), 'clickable': available.IS_CONFLICT_FLG === 'N' && available.SEATS_AVAILABLE > 0 && canAdd}"
									@click="$emit('addCourse', available)">
								<td class="courseInfo col-sm-4">
									<strong :class="{'unavailable': available.IS_CONFLICT_FLG === 'Y' || available.SEATS_AVAILABLE <= 0 }">
										{{ available.COURSE_TITLE }}
										<template v-if="showCourseID">
											({{ available.COURSE_ID }})
										</template>
									</strong>
									<font-awesome-icon icon="info-circle"
																		 v-if="available.topics"
																		 @click="viewAvailableTopics(available)">
									</font-awesome-icon>
									<div class="">
										<small v-if="!!available.TEACHER_NAME && showTeacherName">
											<strong>Teacher:</strong> {{available.TEACHER_NAME}}
										</small>
										<small v-if="(!!available.ROOM_CODE || !!available.ROOM_DESC) && (showRoomCode || showRoomDesc)">
											<strong>Room: </strong>
											<template v-if="showRoomDesc && !!available.ROOM_DESC">{{ available.ROOM_DESC }} </template>
											<template v-if="showRoomCode && !!available.ROOM_CODE">({{ available.ROOM_CODE }})</template>
										</small>
										<small v-if="!!available.DURATION_CODE && showDurationCode">
											<strong v-if="!!available.DURATION_CODE">Duration:</strong> {{ available.DURATION_CODE }}
										</small>
									</div>
									<!-- TODO: Verify if "topics" is a thing, if not remove -->
									<!-- display topics if clicked -->
									<div v-if="available.showTopics" class="course-topics left">
										<div class="topic-head">
											<font-awesome-icon icon="times" @click="available.showTopics = false"></font-awesome-icon>
											<h3>{{ available.course }} Topics</h3>
										</div>
										<ul>
											<li :key="t" v-for="(topic, t) in available.topics">{{ topic }}</li>
										</ul>
									</div>
								</td>
								<td class="col-sm-5">
									<p v-if="showDescriptions">{{ available.COURSE_CATALOG_DESC }}</p>
								</td>
								<td class="col-sm-3 text-right">
									<table class="condensed pull-right">
										<thead>
											<th>Meets period(days):</th>
											<th>seats</th>
										</thead>
										<tbody>
											<td v-html="available.TIMEPATTERN"></td>
											<td>{{ available.SEATS_AVAILABLE }}</td>
										</tbody>
									</table>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</template>
		</modal>

		<modal modal-title="Please Confirm"
					 :show="showConfirm"
					 dialog-size="md"
					 name="confirmModal"
					 :closeText="closeText"
					 @close="closeConfirm()">
			<h4 class="text-center">
				Do you really want to remove {{ selectedCourse.COURSE_TITLE }}?
			</h4>
			<template slot="footer" :close="closeConfirm">
				<button type="button" class="btn btn-default" @click="$emit('removeCourse', selectedMatrixCell)">
					{{ confirmText }}
				</button>
				<button type="button" class="btn btn-default" @click="closeConfirm">
					{{ cancelText }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
	import { Tabs, Tab } from 'vue-tabs-component';

	import Modal from '../shared/Modal/Modal.vue';
	import { ToggleButton } from 'vue-js-toggle-button';

	import { time } from '../../filters/DateTime/time.js';

	export default {
		name: 'StudentScheduler',
		props: {
			selectedStudent: {
				type:			Object,
				required:	true
			},
			selectedCourse: {
				type:			Object,
				required:	true
			},
			classList: {
				type:			Array,
				required:	true
			},
			availableCourses: {
				type:			Array,
				required:	true
			},
			selectedClass: {
				type:			String,
				required:	true
			},
			showModal: {
				type:			Boolean,
				required:	true
			},
			showConfirm: {
				type:			Boolean,
				required:	true
			},
			canAdd: {
				type:			Boolean,
				default:	true
			},
			canRemove: {
				type:			Boolean,
				default:	true
			},
			projectType: {
				type:			String,
				required:	true
			},
			periodDaysText: {
				type: String,
				default: 'Periods / Days'
			},
			emptyText: {
				type: String,
				default: '(empty)'
			},
			loadingMessageText: {
				type: String,
				default: 'Loading schedule configuration...'
			},
			courseConflictMessage: {
				type: String,
				default: 'Oops... it appears your selected course conflicts with another course!'
			},
			filterByText: {
				type: String,
				default: 'Filter by:'
			},
			allDepartmentsText: {
				type: String,
				default: 'All Departments'
			},
			showCourseDescriptionsText: {
				type: String,
				default: 'Show Course Descriptions'
			},
			showUnavailableClassesText: {
				type: String,
				default: 'Show Unavailable Classes'
			},
			confirmText: {
				type: String,
				default: 'Confirm'
			},
			cancelText: {
				type: String,
				default: 'Cancel'
			},
			closeText: {
				type: String,
				default: 'Close'
			}
		},
		data() {
			return {
				showUnavailable:	false,
				showDescriptions: false,
				filterBy: '',
				conflict: false,
				activeTopic: {
					period:	'',
					day:		'',
					course:	'',
					topics:	[]
				},
				selectedMatrixCell: {
					mp:			'',
					period:	'',
					day:		''
				}
			};
		},
		computed: {
			getSelectedClass() {
				let selected = {};

				for(let s in this.classList) {
					let classSelection = this.classList[s];

					if(classSelection.ISCHED_VIEW_CODE === this.selectedClass) {
						selected = classSelection;
					}
				}

				return selected;
			},
			defaultTab() {
				let defaultTab = '';

				if(!!this.selectedCourse) {
					if(!!this.selectedCourse.MARKING_PERIODS) {
						defaultTab = this.selectedCourse.MARKING_PERIODS.length ?
							this.selectedCourse.MARKING_PERIODS[0].MP_CODE : '';
					}
				}

				return defaultTab;
			},
			showDayCode() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('SCREEN_DISPLAY') &&
							 this.getSelectedClass.VIEW_OPTIONS.SCREEN_DISPLAY.includes('DAY_CODE');
			},
			showDayDesc() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('SCREEN_DISPLAY') &&
							 this.getSelectedClass.VIEW_OPTIONS.SCREEN_DISPLAY.includes('DAY_DESC');
			},
			showPeriodCode() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('SCREEN_DISPLAY') &&
							 this.getSelectedClass.VIEW_OPTIONS.SCREEN_DISPLAY.includes('PERIOD_CODE');
			},
			showPeriodDesc() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('SCREEN_DISPLAY') &&
							 this.getSelectedClass.VIEW_OPTIONS.SCREEN_DISPLAY.includes('PERIOD_DESC');
			},
			hasCourseDisplay() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('COURSE_DISPLAY');
			},
			showCourseID() {
				return this.hasCourseDisplay && this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('COURSE_ID');
			},
			showCourseCatalogDesc() {
				return this.hasCourseDisplay &&
							 this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('COURSE_CATALOG_DESC');
			},
			showTeacherName() {
				return this.hasCourseDisplay && this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('TEACHER_NAME');
			},
			showRoomCode() {
				return this.hasCourseDisplay && this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('ROOM_CODE');
			},
			showRoomDesc() {
				return this.hasCourseDisplay && this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('ROOM_DESC');
			},
			showDurationCode() {
				return this.hasCourseDisplay && this.getSelectedClass.VIEW_OPTIONS.COURSE_DISPLAY.includes('DURATION_CODE');
			},
			unavailableCount() {
				return this.availableCourses.filter(course => {
					return course.IS_CONFLICT_FLG === 'Y' || course.IS_CONFLICT_FLG === true || course.IS_CONFLICT_FLG === 1
				}).length;
			},
			showPeriodTimes() {
				return this.getSelectedClass.VIEW_OPTIONS.hasOwnProperty('SCREEN_DISPLAY') &&
							 this.getSelectedClass.VIEW_OPTIONS.SCREEN_DISPLAY.includes('PERIOD_TIMES');
			},
			departments() {
				let departments = [];

				for(let d in this.availableCourses) {
					let department = this.availableCourses[d];

					if(department.DEPARTMENT_CODE.length &&
						 departments.findIndex(d => d.DEPARTMENT_CODE == department.DEPARTMENT_CODE) === -1) {
						departments.push({
							DEPARTMENT_CODE: department.DEPARTMENT_CODE,
							DEPARTMENT_DESC: department.DEPARTMENT_DESC
						});
					}
				}

				return departments;
			}
		},
		components: {
			Tabs,
			Tab,
			Modal,
			FontAwesomeIcon,
			ToggleButton
		},
		directives: {
			'tooltip': VTooltip,
			'close-popover': VClosePopover,
			'v-popover': VPopover
		},
		filters: {
			time: time
		},
		methods: {
			getCellStatus(mp, period, day) {
				return this.isCellFilled(mp, period, day) ? 'filled' : 'empty';
			},
			// returns course info based on day and period
			getCourse(mp, period, day) {
				return this.isCellFilled(mp, period, day) ? this.selectedCourse.CLASSES[mp][period][day] : null;
			},
			isSelectedTopic(period, day) {
				return this.activeTopic.period === period && this.activeTopic.day === day;
			},
			getTopicsClass(period, day) {
				// get index of the day
				let dayIndex = this.selectedClass.DAYS.indexOf(day);

				return dayIndex < 4 ? 'course-topics left' : 'course-topics right';
			},
			getIsRemovable(mp, period, day) {
				let droppable = false;

				if(this.projectType === 'CWP') {
					droppable = this.isCellFilled(mp, period, day) &&
											this.selectedCourse.CLASSES[mp][period][day].IS_DROPPABLE &&
											this.selectedCourse.CLASSES[mp][period][day].ADDED_BY_TYPE === 'S' &&
											this.canRemove;
				} else if(this.projectType === 'LMS') {
					droppable = this.isCellFilled(mp, period, day) &&
											this.selectedCourse.CLASSES[mp][period][day].IS_DROPPABLE &&
											this.canRemove;
				}

				return droppable;
			},
			closeConfirm() {
				this.$emit('updateConfirm');
			},
			getModalTitle() {
				return `Select Class for Marking Period: ${ this.selectedMatrixCell.mp } -
					Period: ${ this.selectedMatrixCell.period } - Day: ${ this.selectedMatrixCell.day }`;
			},
			displayIt(theCourse) {
				return (this.filterBy === '' || theCourse.DEPARTMENT_CODE === this.filterBy) &&
							 ((theCourse.IS_CONFLICT_FLG === 'N' && theCourse.SEATS_AVAILABLE > 0) || this.showUnavailable);
			},
			viewAvailableTopics(course) {
				course.showTopics = !course.showTopics;
			},
			cancelTopic() {
				this.activeTopic.day = '';
				this.activeTopic.period = '';
				this.activeTopic.course = '';
				this.activeTopic.topics = [];
			},
			isCellFilled(mp, period, day) {
				return this.selectedCourse.CLASSES.hasOwnProperty(mp) &&
							 this.selectedCourse.CLASSES[mp].hasOwnProperty(period) &&
							 this.selectedCourse.CLASSES[mp][period].hasOwnProperty(day);
			},
			viewTopics(period, day) {
				// if user click icon again, close topic window
				if(this.activeTopic.period === period && this.activeTopic.day === day) {
					this.cancelTopic();
				} else {
					// show topic for day and course
					this.activeTopic.period = period;
					this.activeTopic.day = day;
					this.activeTopic.course = this.getCourse(period, day).course;
					this.activeTopic.topics = this.getCourse(period, day).topics;
				}
			},
			showAvailableClasses(mp, period, day) {
				this.selectedMatrixCell.mp = mp;
				this.selectedMatrixCell.period = period;
				this.selectedMatrixCell.day = day;

				this.$emit('loadAvailableCourses', mp, period, day);
			},
			confirmCourseRemoval(mp, period, day) {
				// lookup course
				this.selectedMatrixCell.mp = mp;
				this.selectedMatrixCell.period = period;
				this.selectedMatrixCell.day = day;
				this.$emit('updateConfirm');
			}
		}
	}
</script>
